import actions from './actions';

const initState = {
    localServices: [],
    loadingLocalServices: false,
    isRequestingLog: false,
    isDownloadingLog: false,
    pharmacy: {},
    loadingPharmacy: false,
    isUpdatingSettings: false,
    pharmacies: [],
    isDownloadingConfig: false,
    isCreatingLocalService: false,
    service: {},
    unresolvedEvents: [],
    loadingUnresolvedEvents: false,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_LOCAL_SERVICES:
            return {
                ...state,
                loadingLocalServices: true,
            };
        case actions.FETCH_LOCAL_SERVICES_SUCCESS:
            return {
                ...state,
                localServices: action.services,
                loadingLocalServices: false,
            };
        case actions.FETCH_LOCAL_SERVICES_SUCCESS_ERROR:
            return {
                ...state,
                localServices: [],
                loadingLocalServices: false,
            };
        case actions.DOWNLOAD_SERVICE_LOG:
            return {
                ...state,
                loadingLocalServices: true,
            };
        case actions.DOWNLOAD_SERVICE_LOG_SUCCESS:
            return {
                ...state,
                loadingLocalServices: false,
            };
        case actions.DOWNLOAD_SERVICE_LOG_ERROR:
            return {
                ...state,
                loadingLocalServices: false,
            };
        case actions.REQUEST_SERVICE_LOG:
            return {
                ...state,
                loadingLocalServices: true,
            };
        case actions.REQUEST_SERVICE_LOG_ERROR:
            return {
                ...state,
                loadingLocalServices: false,
            };
        case actions.FETCH_LOCAL_SERVICE_PHARMACY:
            return {
                ...state,
                loadingPharmacy: true,
            };
        case actions.FETCH_LOCAL_SERVICE_PHARMACY_SUCCESS:
            return {
                ...state,
                loadingPharmacy: false,
                pharmacy: action.pharmacy,
            };
        case actions.FETCH_LOCAL_SERVICE_PHARMACY_ERROR:
            return {
                ...state,
                loadingPharmacy: false,
                pharmacy: {},
            };
        case actions.LOCAL_SERVICE_PHARMACY_UPDATE:
            return {
                ...state,
                isUpdatingSettings: true,
            };
        case actions.LOCAL_SERVICE_PHARMACY_UPDATE_SUCCESS:
            return {
                ...state,
                isUpdatingSettings: false,
            };
        case actions.LOCAL_SERVICE_PHARMACY_UPDATE_ERROR:
            return {
                ...state,
                isUpdatingSettings: false,
            };
        case actions.FETCH_LOCAL_SERVICE_PHARMACIES:
            return {
                ...state,
            };
        case actions.FETCH_LOCAL_SERVICE_PHARMACIES_SUCCESS:
            return {
                ...state,
                pharmacies: action.pharmacies,
            };
        case actions.FETCH_LOCAL_SERVICE_PHARMACIES_ERROR:
            return {
                ...state,
                pharmacies: [],
            };
        case actions.DOWNLOAD_SERVICE_CONFIG:
            return {
                ...state,
                isDownloadingConfig: true,
            };
        case actions.DOWNLOAD_SERVICE_CONFIG_SUCCESS:
            return {
                ...state,
                isDownloadingConfig: false,
            };
        case actions.DOWNLOAD_SERVICE_CONFIG_ERROR:
            return {
                ...state,
                isDownloadingConfig: false,
            };
        case actions.CREATE_LOCAL_SERVICE:
            return {
                ...state,
                isCreatingLocalService: true,
            };
        case actions.CREATE_LOCAL_SERVICE_SUCCESS:
            return {
                ...state,
                service: action.local_service,
                isCreatingLocalService: false,
            };
        case actions.CREATE_LOCAL_SERVICE_ERROR:
            return {
                ...state,
                service: {},
                isCreatingLocalService: false,
            };
        case actions.FETCH_UNRESOLVED_EVENTS:
            return {
                ...state,
                loadingUnresolvedEvents: true,
            };
        case actions.FETCH_UNRESOLVED_EVENTS_SUCCESS:
            return {
                ...state,
                unresolvedEvents: action.events,
                loadingUnresolvedEvents: false,
            };
        case actions.FETCH_UNRESOLVED_EVENTS_ERROR:
            return {
                ...state,
                unresolvedEvents: [],
                loadingUnresolvedEvents: false,
            };
        default:
            return state;
    }
}
